export const unwrap = (el) => {
  const parent = el.parentElement;
  if (parent.tagName !== 'BODY') {
    parent.replaceWith(parent.childNodes);
  }
  return el;
};

export const parse = (html) => {
  const doc = document.createElement('html');
  doc.innerHTML = html;
  return doc.lastChild;
};
